/*
 * Device helpers
 * 判断是否为手机设备（尽量兼容、实用）。
 * 逻辑优先级：
 * 1) UA-CH (navigator.userAgentData.mobile)
 * 2) iPadOS 伪装成 Mac 的修正
 * 3) 常见 UA 关键词
 * 4) (pointer:coarse) + 小屏兜底，减少触控笔记本误判
 */

export function isMobileDevice() {
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;
  const win = typeof window !== 'undefined' ? window : undefined;

  // 1) UA-CH：新版 Chrome/Edge 支持
  const uaClientHintsMobile = !!(
    nav && nav.userAgentData && typeof nav.userAgentData.mobile === 'boolean' && nav.userAgentData.mobile
  );

  // 2) UA 字符串
  const ua = nav ? (nav.userAgent || nav.vendor || (win && win.opera) || '') : '';
  const uaMobile = /Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  // 3) iPadOS 识别（iOS13+ 可能伪装成 Mac）
  const isIPadOS = !!(nav && nav.platform === 'MacIntel' && nav.maxTouchPoints > 1);

  // 4) 指针粗细与屏幕尺寸兜底
  const coarsePointer = !!(win && win.matchMedia && win.matchMedia('(pointer:coarse)').matches);
  const smallScreen = !!(win && Math.min(win.screen.width, win.screen.height) < 820);

  return !!(
    uaClientHintsMobile ||
    uaMobile ||
    isIPadOS ||
    (coarsePointer && smallScreen)
  );
}

// 便捷：同时导出默认，方便按需引入
export default isMobileDevice;
